import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store, Tienda, CreateStoreDto, UpdateStoreDto } from 'app/models/tienda.models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { EmpresaService } from './empresa.service';

@Injectable({
  providedIn: 'root'
})
export class TiendaService {
  
  private apiUrl = `${environment.apiUrl}store`;

  constructor(
    private http: HttpClient,
    private empresaService: EmpresaService
  ) { }

  /**
   * Obtiene la store/tienda actual por companyId
   */
  getStore(): Observable<Store> {
    return this.empresaService.getEmpresaConfig().pipe(
      switchMap((empresa: any) => {
        if (empresa && empresa.id) {
          // Usar el ID de la empresa como companyId en el endpoint /store/:companyId
          return this.http.get<Store>(`${this.apiUrl}/${empresa.id}`);
        } else {
          throw new Error('No se pudo obtener el ID de la empresa');
        }
      })
    );
  }

  /**
   * Crea una nueva store
   */
  createStore(storeData: CreateStoreDto): Observable<Store> {
    return this.http.post<Store>(this.apiUrl, storeData);
  }

  /**
   * Actualiza una store existente
   */
  updateStore(id: number, storeData: UpdateStoreDto): Observable<Store> {
    return this.http.patch<Store>(`${this.apiUrl}/${id}`, storeData);
  }

  /**
   * Elimina una store
   */
  deleteStore(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  /**
   * Obtiene una store por ID
   */
  getStoreById(id: number): Observable<Store> {
    return this.http.get<Store>(`${this.apiUrl}/${id}`);
  }

  // Métodos de compatibilidad hacia atrás
  
  /**
   * @deprecated Usar getStore() en su lugar
   */
  getTienda(): Observable<Tienda | any> {
    return this.http.get(this.apiUrl);
  }

  /**
   * @deprecated Usar createStore() o updateStore() en su lugar
   */
  guardar(tienda: Tienda): Observable<any> {
    return this.http.post(this.apiUrl, tienda);
  }

  /**
   * @deprecated Usar updateStore() en su lugar
   */
  actualizar(tienda: Tienda): Observable<any> {
    return this.http.patch(`${this.apiUrl}/${tienda.id}`, tienda);
  }

  /**
   * @deprecated Usar deleteStore() en su lugar
   */
  eliminar(tienda: Tienda): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${tienda.id}`);
  }
}
